type NormalizeHostOptionsT = {
  stripPort?: boolean;
  stripWww?: boolean;
};

export const normalizeHost = (
  host?: string | null,
  options: NormalizeHostOptionsT = {}
): string => {
  if (!host) {
    return "";
  }

  const normalizedHost = host.trim().toLowerCase();
  const hostWithoutPort = options.stripPort
    ? normalizedHost.split(":")[0]
    : normalizedHost;

  return options.stripWww
    ? hostWithoutPort.replace(/^www\./, "")
    : hostWithoutPort;
};
